import { render, staticRenderFns } from "./SectionCounter.vue?vue&type=template&id=78a45a6e&scoped=true&"
import script from "./SectionCounter.vue?vue&type=script&lang=js&"
export * from "./SectionCounter.vue?vue&type=script&lang=js&"
import style0 from "./SectionCounter.vue?vue&type=style&index=0&id=78a45a6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a45a6e",
  null
  
)

export default component.exports